import React from "react";
import { CFooter } from "@coreui/react-pro";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { useNavigate } from "react-router-dom";
import "../scss/AppFooter.scss";
const AppFooter = () => {
  const navigate = useNavigate();
  return (
    <CFooter className="bg-info">
      <div className="container d-flex justify-content-between p-5 position-relative">
        <div className="social-icons-section">
          <p className="copyright-text text-danger">
            Copyright and patent pending
          </p>
          <div className="justify-content-around d-flex p-2 bd-highlight">
            <span className="text-light ms-1">
              <InstagramIcon />
            </span>
            <span className="text-light ms-1">
              <FacebookIcon />
            </span>
            <span className="text-light ms-1">
              <LinkedInIcon />
            </span>
            <span className="text-light ms-1">
              <TwitterIcon />
            </span>
            <span className="text-light ms-1">
              <YouTubeIcon />
            </span>
          </div>
        </div>
        <div className="d-flex">
          <div className="d-flex flex-column p-2 bd-highlight">
            <a
              onClick={() => navigate("/")}
              className="p-2 bd-highlight text-primary fw-bold text-decoration-none"
            >
              Home
            </a>
            <a
              onClick={() => navigate("/map-hotels")}
              className="p-2 bd-highlight text-primary fw-bold text-decoration-none"
            >
              Reserve
            </a>
            <a
              onClick={() => navigate("/about")}
              className="p-2 bd-highlight text-primary fw-bold text-decoration-none"
            >
              About
            </a>
            <a
              onClick={() => navigate("/FAQ")}
              className="p-2 bd-highlight text-primary fw-bold text-decoration-none"
            >
              FAQs
            </a>
            <a
              onClick={() => navigate("/Contact")}
              className="p-2 bd-highlight text-primary fw-bold text-decoration-none"
            >
              Contact
            </a>
          </div>
          <div className="d-flex flex-column p-2 bd-highlight">
            <a
              href=""
              className="p-2 bd-highlight text-primary fw-bold text-decoration-none"
            >
              News
            </a>
            <a
              href=""
              className="p-2 bd-highlight text-primary fw-bold text-decoration-none"
            >
              TechLauncher
            </a>
            <a
              href=""
              className="p-2 bd-highlight text-primary fw-bold text-decoration-none"
            >
              Hotels
            </a>
            <a
              href=""
              className="p-2 bd-highlight text-primary fw-bold text-decoration-none"
            >
              Terms
            </a>
          </div>
        </div>
        <div className="d-flex flex-column p-2 bd-highlight address-info">
          <p className="text-danger">Shower Away Pty Ltd</p>
          <p className="text-danger">
            Suite 1088, 30 Denison St, Bondi NSW 2022
          </p>
          <p className="text-danger">
            Suite 111, 11 Palmerston Ln, Manuka ACT 2603
          </p>
          <p className="text-danger">
            Australian Business Number: 60 661 931 684
          </p>
          <p className="text-danger">0430 525 188 (Peter) </p>
          <a href="mailto:hello@showeraway.com" className="text-light">
            hello@showeraway.com
          </a>
        </div>
        <p className="position-absolute bottom-0 start-0 text-danger">
          © 2023{" "}
        </p>
      </div>
    </CFooter>
  );
};

export default React.memo(AppFooter);
